import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

function useTradingTime() {
  const { cb, key } = fetch();
  const { data, isSuccess, refetch } = useQuery(key, cb);

  /** True when status is OPEN, false when BREAK|CLOSED|ERROR */
  const isMarketOpen = data?.status === 'OPEN';
  /** True when status is BREAK|CLOSED|ERROR, false when OPEN */
  const isMarketClosed = data?.status !== 'OPEN';
  /** True when status is BREAK, false when OPEN|CLOSED|ERROR */
  const isMarketBreak = data?.status === 'BREAK';

  return { data, isSuccess, refetch, isMarketOpen, isMarketClosed, isMarketBreak };
}

export default {
  useTradingTime,
};
